import dayjs from "dayjs";

export const formatDateTime = {
  getFullDate: (date: Date) => {
    return dayjs(date).format("DD/MM/YYYY");
  },
  getDateDay: (date: Date) => {
    const dayFormat: string =
      dayjs(date).format("DD") === dayjs(new Date()).format("DD")
        ? "Hoje"
        : dayjs(date).format("DD");

    return dayFormat;
  },
  getDateMouth: (date: Date) => {
    return dayjs(date).format("MM");
  },
  getDateYear: (date: Date) => {
    return dayjs(date).format("YYYY");
  },
  getFullTime: (date: Date) => {
    return dayjs(date).format("HH:mm:ss");
  },
  getHour: (date: Date) => {
    return dayjs(date).format("HH");
  },
  getMinutes: (date: Date) => {
    return dayjs(date).format("mm");
  },
  getSeconds: (date: Date) => {
    return dayjs(date).format("ss");
  },
  convertTicksToDate: (ticks: number) => {
    const milliseconds = ticks / 10000;
    const date = new Date(milliseconds);

    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  },
  convertTicksToTime: (ticks: number) => {
    const milliseconds = ticks / 10000;
    const date = new Date(milliseconds);

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    return formattedTime;
  },
};
